export default "__VITE_ASSET__Dp4ZimbC__"